import { useMemo } from 'react';
import { Box } from '@mui/material';
import { useFormik } from 'formik';

import { FProgressBar } from '../../../../../../components/base';
import { useFormReadOnly } from '../../../../../common';
import AssessmentInfoFields from './AssessmentInfoFields';
import { getAssessmentInfoFieldCompareValue } from '../hooks';
import { useSaveTreatmentPlanV3PageField } from '../../../../hooks';
import { mapAssessmentPageToInfoValues, toAssessmentInfoFieldPayload } from '../utils';
import { ASSESSMENT_INFO_FORM_SCHEMA } from '../validationSchema';

import type { AssessmentInfoSectionProps } from './types';

export default function AssessmentInfoSection({
  assessmentPage,
  templates,
  disabled,
  isUpdating,
  onUpdate,
}: AssessmentInfoSectionProps) {
  const readOnly = useFormReadOnly();
  const initialValues = useMemo(
    () => mapAssessmentPageToInfoValues(assessmentPage),
    [assessmentPage],
  );
  const formik = useFormik({
    initialValues,
    validateOnBlur: true,
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: ASSESSMENT_INFO_FORM_SCHEMA,
    onSubmit: () => undefined,
  });
  const { saveField } = useSaveTreatmentPlanV3PageField({
    formik,
    getCompareValue: getAssessmentInfoFieldCompareValue,
    initialValues,
    onUpdate,
    toPayload: toAssessmentInfoFieldPayload,
    validationSchema: ASSESSMENT_INFO_FORM_SCHEMA,
  });

  return (
    <Box component="form" noValidate onSubmit={formik.handleSubmit}>
      {isUpdating ? <FProgressBar /> : null}
      <AssessmentInfoFields
        disabled={disabled}
        formik={formik}
        readOnly={readOnly}
        saveField={saveField}
        templates={templates}
      />
    </Box>
  );
}
